import {Box, Typography} from '@mui/material';
import MenuWrapper from '../MenuWrapper/MenuWrapper';
import './RedactionMenu.scss';
import {t} from 'i18next';
import {InfoOutline} from '@mui/icons-material';
import ArrTooltipWrapper from '../../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../redux/store';
import SelectionModeToggleButton from '../selection-mode-toggle-button/SelectionModeToggleButton';
import {MouseToolType} from '../../../docViewerUtils';
import {useCallback, useState} from 'react';
import {ISelectItem} from '../../../../../shared/types';
import MultipageRedaction from '../../../components/multipage-redaction/MultipageRedaction';
import SingleRedactionPopup from './SingleRedactionPopup';

const enRedactionMenu = 'docView.redationMenu';
export const RedactionMenu = ({
  selectionMode,
  setSelectionMode,
  onFullPage,
  onMultiPage,
  totalPages,
  showWarning,
}: {
  selectionMode: string | null;
  setSelectionMode: React.Dispatch<React.SetStateAction<string | null>>;
  onFullPage: (value: ISelectItem) => void;
  onMultiPage: (value: ISelectItem, pages: number[]) => void;
  totalPages?: number;
  showWarning: boolean;
}) => {
  const {reductionPropagation: isReductionPropagation} = useSelector(
    (state: RootState) => state.docView
  );
  const [selectedValue, setSelectedValue] = useState<ISelectItem | null>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [isMultipageRedaction, setIsMultipageRedaction] = useState(false);
  const toggleSingeRedactionPopup = useCallback(() => {
    setSelectedValue(null);
    setIsOpen((prev) => !prev);
  }, [setIsOpen]);
  const saveFullPageRedaction = () => {
    selectedValue && onFullPage(selectedValue);
    toggleSingeRedactionPopup();
    setSelectedValue(null);
  };
  const saveMultiPageRedaction = (pages: number[]) => {
    selectedValue && onMultiPage(selectedValue, pages);
  };
  return (
    <MenuWrapper>
      <>
        {isOpen && (
          <SingleRedactionPopup
            closeSingeRedactionPopup={toggleSingeRedactionPopup}
            saveSingleRedaction={saveFullPageRedaction}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
          />
        )}
        <Box className="redact-menu-wrapper-box">
          {isReductionPropagation && (
            <Box
              className="redact-note-box"
              data-testid="propagation-note-text"
            >
              <Typography
                className="typo-text body4_size redaction-note"
                data-testid="redaction-note"
              >
                {t(`${enRedactionMenu}.redactionPropagationNote`)}&nbsp;
              </Typography>

              <ArrTooltipWrapper
                trigger={
                  <InfoOutline
                    fontSize="small"
                    className="info-icon"
                    data-tab-id="propagation-note-text-tooltip-icon"
                    data-tab-group="center-panel"
                    data-testid="info-icon"
                  />
                }
              >
                <Typography
                  className="typo-text label3_size"
                  data-testid={`redaction-menu-typography`}
                >
                  {t(`${enRedactionMenu}.redactionPropagationNoteTooltip`)}
                </Typography>
                <Typography
                  className="typo-text label3_size"
                  data-testid={`redaction-menu-typography-text`}
                >
                  &nbsp;
                </Typography>
                <Typography
                  className="typo-text label3_size"
                  data-testid={`redaction-menu-typography-propagation-note`}
                >
                  {t(`${enRedactionMenu}.redactionPropagationNoteTooltipTitle`)}
                </Typography>
              </ArrTooltipWrapper>
            </Box>
          )}
        </Box>
        <>
          <SelectionModeToggleButton
            text={t(`${enRedactionMenu}.rectangle`)}
            isActive={selectionMode === MouseToolType.RectangleRedaction}
            disabled={showWarning}
            dataTestId="rectangle-redaction"
            onClick={() => {
              setSelectionMode((prev) =>
                prev === MouseToolType.RectangleRedaction
                  ? null
                  : MouseToolType.RectangleRedaction
              );
            }}
          />
          <SelectionModeToggleButton
            text={t(`${enRedactionMenu}.textRedact`)}
            isActive={selectionMode === MouseToolType.TextSelectionRedaction}
            dataTestId="text-redaction"
            disabled={showWarning}
            onClick={() => {
              setSelectionMode((prev) =>
                prev === MouseToolType.TextSelectionRedaction
                  ? null
                  : MouseToolType.TextSelectionRedaction
              );
            }}
          />
          <SelectionModeToggleButton
            text={t(`${enRedactionMenu}.page`)}
            isActive={false}
            dataTestId="full-page-redaction"
            disabled={showWarning}
            onClick={() => {
              setSelectionMode('FullPageRedaction');
              toggleSingeRedactionPopup();
            }}
          />
          <SelectionModeToggleButton
            text={t(`${enRedactionMenu}.multiPage`)}
            isActive={isMultipageRedaction}
            dataTestId="multi-page-redaction"
            disabled={showWarning}
            onClick={() => {
              setIsMultipageRedaction(true);
              setSelectionMode('MultiPageRedaction');
            }}
          />
        </>
        {isMultipageRedaction && totalPages && (
          <MultipageRedaction
            onClose={() => {
              setIsMultipageRedaction(false);
            }}
            saveMultiPageRedaction={saveMultiPageRedaction}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            totalPages={totalPages}
          />
        )}
      </>
    </MenuWrapper>
  );
};
